import { useUIStore } from "../../stores/ui";

export function AmbientBackground() {
  const resolvedTheme = useUIStore((s) => s.resolvedTheme);
  const focusMode = useUIStore((s) => s.focusMode);

  const isDark = resolvedTheme === "dark";

  return (
    <div
      className="pointer-events-none fixed inset-0 -z-[1]"
      aria-hidden
      style={{
        background: isDark
          ? `radial-gradient(ellipse 80% 60% at 50% 0%, rgba(255, 92, 0, 0.015) 0%, transparent 60%),
             linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%)`
          : `radial-gradient(ellipse 80% 60% at 50% 0%, rgba(255, 92, 0, 0.02) 0%, transparent 60%),
             linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%)`,
        opacity: focusMode ? 0.85 : 1,
        transition: "opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1), background 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
      }}
    />
  );
}
